import type * as React from 'react'
import isEqual from 'lodash/isEqual'
import uniqWith from 'lodash/uniqWith'
import { Services } from '../../AppConstants'
import type { ValidationFeedback } from '../../stores/types'
import { ExternalLinkIcon, Link } from '@buffer-mono/popcorn'
import styles from './styles.module.css'

export const getFormattedWhatPreventsSavingMessages = ({
  warningMessages,
}: {
  warningMessages: ValidationFeedback[]
}): Array<React.ReactElement | string> | null => {
  if (warningMessages.length === 0) {
    return null
  }

  const messages = uniqWith(warningMessages, isEqual).reduce<
    Array<React.ReactElement | string>
  >((finalMessages, what) => {
    let message: string | React.ReactElement = what.message
    const metadata = what.metadata

    // First make sure we can determine the composer service
    // before adding it to the error message
    const composerService = Services.get(what.composerId)
    if (composerService) {
      message = message + ` for ${composerService.formattedName}`
    }

    if (metadata?.learnMoreLink && typeof metadata.learnMoreLink === 'string') {
      const learnMoreText =
        typeof metadata.learnMoreText === 'string'
          ? metadata.learnMoreText
          : `Learn more`
      message = (
        <span>
          {message}{' '}
          <Link
            className={styles.learnMoreToolipLink}
            href={metadata.learnMoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {learnMoreText} <ExternalLinkIcon />
          </Link>
        </span>
      )
    }

    finalMessages.push(message)
    return finalMessages
  }, [])

  return messages.length === 1
    ? // If there is only one message, just return it as a string
      // to avoid list formatting
      messages
    : messages.map((message, index) => (
        <p className={styles.bullet} key={index}>
          {message}
        </p>
      ))
}
